import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import AdvancedCombobox from '../Helper/AdvancedCombobox';
import Combobox from '../Helper/Combobox';
import ControlledGrid from '../Helper/ControlledGrid';
import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Alerte from './Alerte';
import Contrat from './Contrat';
import Document from './Document';
import DonneurOrdre from './DonneurOrdre';
import Financeur from './Financeur';
import MotCle from './MotCle';
import Projet from './Projet';
import Responsable from './Responsable';
import Thematique from './Thematique';

/**
* Class Objectif
* Objectif view component
**/
class Objectif extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Objectif";
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading object if it doesn't exist
  **/
  componentWillMount() {

    if(this.state.object === undefined) {
      const pathName = this.getObjectPath();

      rest({method: 'GET', path: REST_API_URL + pathName}).then(response => {
        let state = this.state;
        let obj = JSON.parse(response.entity);

        obj.dateDebut = getDateFromString(obj.dateDebut);
        obj.dateFin = getDateFromString(obj.dateFin);

        state.object = obj;

        this.setState(state)
      });
    }
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    const goBack = <Button bsStyle="link" onClick={this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateDebut = null, dateFin = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateDebut) {

        dateDebut = this.state.object.dateDebut;

        if(typeof dateDebut === "string") {
          dateDebut = getDateFromString(dateDebut);
        }

        dateDebut = getIsoStringFromDate(dateDebut);
      }

      if(this.state.object.dateFin) {

        dateFin = this.state.object.dateFin;

        if(typeof dateFin === "string") {
          dateFin = getDateFromString(dateFin);
        }

        dateFin = getIsoStringFromDate(dateFin);
      }
    }

    const cbxEstContratProps = {
      dataSource: {
          collection: [{
            id: true,
            name: "occupation"
          },{
            id: false,
            name: "projets"
          }]
      },
      onChange: this.handleEstContratChange.bind(this),
      default: (this.state.mode !== "add") ? this.getObjectProperty("estContrat") : false,
      disabled: this.state.mode !== "add",
      forceSelection: true
    };

    // Rendering the view
		return (
      <div>
        {goBack}
        {/* Status information */}
        {status}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'objectif.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idObjectif" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idObjectif")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Date de début</Col>
            <Col sm={2}><DatePicker id="dateDebut" dateFormat="DD/MM/YYYY" value={dateDebut} onChange={this.handleDateDebutChange} disabled={this.getReadOnly()} /></Col>
            <Col componentClass={ControlLabel} sm={2}>Date de fin</Col>
            <Col sm={2}><DatePicker id="dateFin" minDate={dateDebut} dateFormat="DD/MM/YYYY" value={dateFin} onChange={this.handleDateFinChange} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="estContrat">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>L'objectif concerne des</ControlLabel></Col>
            <Col sm={2}><Combobox {...cbxEstContratProps} /></Col>
          </FormGroup>

          {/* Responsable OneToMany */}
          <PermissionCheck component={Responsable.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="idResponsable">
              <Col componentClass={ControlLabel} sm={2}>Responsable</Col>
              <Col sm={4}><AdvancedCombobox  path="responsables" objectPath={this.getObjectPath() + "responsables"} objectClass={Responsable} url={REST_API_URL + "responsables/"}
              optionValueKey="idResponsable" optionLabelKey="libelleResponsable" default={this.getObjectProperty("idResponsable")} onChange={this.handleResponsableChange}
              disabled={this.getReadOnly()} enableSearch={true} /></Col>
            </FormGroup>
          </PermissionCheck>

          {/* <FormGroup>
            <PermissionCheck component={DonneurOrdre.getClassName()} permission={PERMISSION_READ}>
              <div>
                <Col componentClass={ControlLabel} sm={2}>Donneurs d'ordre</Col>
                <Col sm={3}>
                  <ControlledGrid ref="donneurordresGrid" path="donneurordres" objectPath={"objectifs_donneurordres/" + this.getObjectProperty("idObjectif") + "/donneurordres"}
                  objectClass={DonneurOrdre} mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_donneurordres/" + this.getObjectProperty("idObjectif") + "/donneurordres/inverse/"}
                  optionValueKey="idDonneurOrdre" optionLabelKey="libelleDonneurOrdre" />
                </Col>
              </div>
            </PermissionCheck>

            <PermissionCheck component={Financeur.getClassName()} permission={PERMISSION_READ}>
              <div>
                <Col componentClass={ControlLabel} sm={1}>Financeurs</Col>
                <Col sm={3}>
                  <ControlledGrid ref="financeursGrid" path="financeurs" objectPath={"objectifs_financeurs/" + this.getObjectProperty("idObjectif") + "/financeurs"}
                  objectClass={Financeur} mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_financeurs/" + this.getObjectProperty("idObjectif") + "/financeurs/inverse/"}
                  optionValueKey="idFinanceur" optionLabelKey="libelleFinanceur" />
                </Col>
              </div>
            </PermissionCheck>
          </FormGroup> */}

          {/* DonneurOrdre ManyToMany */}
          <PermissionCheck component={DonneurOrdre.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="donneurOrdres">
              <Col componentClass={ControlLabel} sm={2}>Donneurs d'ordre</Col>
              <Col sm={6}>
              {/* disableAdd={true} */}
                <ControlledGrid  ref="donneurordresGrid" path="donneurordres" objectPath={"objectifs_donneurordres/" + this.getObjectProperty("idObjectif") + "/donneurordres"}
                objectClass={DonneurOrdre} mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_donneurordres/" + this.getObjectProperty("idObjectif") + "/donneurordres/inverse/"}
                optionValueKey="idDonneurOrdre" optionLabelKey="libelleDonneurOrdre" />
              </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Financeur ManyToMany */}
          <PermissionCheck component={Financeur.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="financeurs">
              <Col componentClass={ControlLabel} sm={2}>Financeurs</Col>
              <Col sm={6}>
                <ControlledGrid ref="financeursGrid" path="financeurs" objectPath={"objectifs_financeurs/" + this.getObjectProperty("idObjectif") + "/financeurs"}
                objectClass={Financeur} mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_financeurs/" + this.getObjectProperty("idObjectif") + "/financeurs/inverse/"}
                optionValueKey="idFinanceur" optionLabelKey="libelleFinanceur" />
              </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Thematique ManyToMany */}
          <PermissionCheck component={Thematique.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="thematiques">
              <Col componentClass={ControlLabel} sm={2}>Thématiques</Col>
              <Col sm={6}>
                <ControlledGrid ref="thematiquesGrid" path="thematiques" objectPath={"objectifs_thematiques/" + this.getObjectProperty("idObjectif") + "/thematiques"}
                objectClass={Thematique} mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_thematiques/" + this.getObjectProperty("idObjectif") + "/thematiques/inverse/"}
                optionValueKey="idThematique" optionLabelKey="libelle" />
              </Col>
            </FormGroup>
          </PermissionCheck>

          {/* MotCle ManyToMany */}
          <PermissionCheck component={MotCle.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="motCles">
              <Col componentClass={ControlLabel} sm={2}>Mots clé</Col>
              <Col sm={6}>
                <ControlledGrid ref="motclesGrid" path="motcles" objectPath={"objectifs_motcles/" + this.getObjectProperty("idObjectif") + "/motcles"} objectClass={MotCle}
                mode={this.state.mode} cbxUrl={REST_API_URL + "objectifs_motcles/" + this.getObjectProperty("idObjectif") + "/motcles/inverse/"} optionValueKey="idMotCle"
                optionLabelKey="libelle" />
              </Col>
            </FormGroup>
          </PermissionCheck>

          <FormGroup controlId="commentaire1">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire1")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire2">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire 2</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire2")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Alerte OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" path="alertes" objectPath={"objectifs/" + this.getObjectProperty(this.getIdField()) + "/alertes"} objectClass={Alerte}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {(this.state.mode !== "add") &&
            <GeometryGrid title="Géométries" path="objectifs_geoms" objectPath={"objectifs_geoms/" + this.getObjectProperty("idObjectif")} objectClass={Objectif} mode={this.state.mode}
              queryLayers="ObjectifCreate" allowDraw={true} selectionMultiple={true} typeGeometry="all" withImportCsv={false} withImportPoint={false} />
          }

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"objectifs/" + this.getObjectProperty(this.getIdField()) + "/documents"} objectClass={Document}
              hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Projet OneToMany */}
          {(this.state.mode !== "add" && this.getObjectProperty("estContrat") === false) &&
            <PermissionCheck component={Projet.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Projets" path="projets" objectPath={"objectifs/" + this.getObjectProperty("idObjectif")+ "/projets"} objectClass={Projet} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Contrat OneToMany */}
          {(this.state.mode !== "add" && this.getObjectProperty("estContrat") === true) &&
            <PermissionCheck component={Contrat.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Contrats" path="contrats" objectPath={"objectifs/" + this.getObjectProperty("idObjectif")+ "/contrats"} objectClass={Contrat} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }



          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idObjectif";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    let objectifObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.donneurordresGrid !== undefined) objectifObj.donneurOrdres = this.refs.donneurordresGrid.getArrayToSave();
      if(this.refs.financeursGrid !== undefined) objectifObj.financeurs = this.refs.financeursGrid.getArrayToSave();
      if(this.refs.thematiquesGrid !== undefined) objectifObj.thematiques = this.refs.thematiquesGrid.getArrayToSave();
      if(this.refs.motclesGrid !== undefined) objectifObj.motCles = this.refs.motclesGrid.getArrayToSave();
    }

    if(typeof objectifObj.dateDebut !== "string") {
      objectifObj.dateDebut = getStringFromDate(objectifObj.dateDebut);
    }

    if(typeof objectifObj.dateFin !== "string") {
      objectifObj.dateFin = getStringFromDate(objectifObj.dateFin);
    }

    if(objectifObj.estContrat === undefined) {
      objectifObj.estContrat = false;
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(objectifObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();

        this.setState({
          status: {
            type: 'success',
            message: 'Objectif sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Objectif créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/objectifs/" + newObj.idObjectif + "/edit", state);

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.donneurordresGrid !== undefined) this.refs.donneurordresGrid.saveAll();
    if(this.refs.financeursGrid !== undefined) this.refs.financeursGrid.saveAll();
    if(this.refs.thematiquesGrid !== undefined) this.refs.thematiquesGrid.saveAll();
    if(this.refs.motclesGrid !== undefined) this.refs.motclesGrid.saveAll();
  }

  /**
  * handleEstContratChange
  * Handle estContrat onChange event
  **/
  handleEstContratChange(estContrat) {
    let objState = this.state;
    objState.object["estContrat"] = (estContrat) ? estContrat.id : false;
    this.setState(objState);
  }

}
export default Objectif;



// WEBPACK FOOTER //
// ./src/views/Entity/Objectif.js